var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_1404)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_449_1404",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "url(#pattern0_449_1404)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_449_1404)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_449_1404",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_449_1404",
    transform: "scale(0.0416667 0.047619)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_1404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_449_1404",
    width: 24,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAMAAABrN94UAAAAAXNSR0IB2cksfwAAAPBQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ZmikqQAAAFB0Uk5T0+ztugDv/9LH3q8JCgghJR34w+6/1qkFFGWXjk4BKC0mAjbgsA3i/NgDE+OY8OVjYYP79yDEp5RgS4qLD9T+PUbB1+molo/moBtDORKNnp1mNqrTAAAAt0lEQVR4nHWR1RLCQAxFFwhBiru7u7u78/9/w0J32mmA83pmcm8SxnRa9Ab4wIxIMAlhthCsQkg2gl0I+ANzOAkuISxugkcI779WPj8hIERQixpOyoTCkWgs/haJpEIqDZnsOyaX56JQVCiVK1W5QI2LutqnAU3EbKvdwW4PmLWvMIAh4gjAgDgm4RPEKczmuFgSseID1xvEbZ6I8k5OK+7pHtKBn+jI1enr7OfL9XZHfPz+R+QJLwL1HElBNy40AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSearchBlack);
export default __webpack_public_path__ + "static/media/saveSearchBlack.f4769413fbb71a7245c97499075d4196.svg";
export { ForwardRef as ReactComponent };